const BIG = 'big';
const MEDIUM = 'medium';
const SMALL = 'small';

export default {
  BIG,
  MEDIUM,
  SMALL,
};
